import { Box, Icon, styled } from "@tm/components"

const StyledBox = styled(Box, {
    shouldForwardProp: (prop) => prop !== "is3dConfigurator",
})<{ is3dConfigurator?: boolean }>(({ is3dConfigurator }) => ({
    display: "flex",
    gap: "0.5em",
    position: "absolute",
    top: is3dConfigurator ? "75%" : "77%",
    zIndex: 1,
    marginLeft: is3dConfigurator ? "39em" : "46em",
}))

const StyledIcon = styled(Icon)<{ disabled?: boolean; themeColor?: string }>(({ themeColor, disabled, theme }) => ({
    width: "1.5em",
    height: "1.5em",

    ":hover": {
        background: "none",
        cursor: "pointer",
        fill: themeColor || theme?.colors?.primary,
    },

    ...(disabled && { cursor: "default", opacity: theme.opacity?.disabled }),
}))

type Props = {
    onClickButton?: () => void
    onOpenDialog: () => void
    disabled?: boolean
    is3dConfigurator?: boolean
    themeColor?: string
}

function VehicleActions({ onClickButton, onOpenDialog, disabled, is3dConfigurator, themeColor }: Props) {
    return (
        <StyledBox is3dConfigurator={is3dConfigurator}>
            <StyledIcon name="edit_change" onClick={onClickButton} disabled={disabled} themeColor={themeColor} />
            <StyledIcon name="no-results" onClick={onOpenDialog} themeColor={themeColor} />
        </StyledBox>
    )
}

export default VehicleActions
